import { h } from '@stencil/core';

const WarningIcon = ({ width = '24', height = '24', strokeWidth = '2.5' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="-0.5 -0.5 25 25" fill="none">
      <path d="M11.7782 6.12598V13.806" stroke="currentColor" stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.7782 17.9082V18.5627" stroke="currentColor" stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0099 1.373047H7.14997L1.372559 7.61073V16.4706L7.14997 22.748H16.0099L21.7476 16.4706V7.61073L16.0099 1.373047Z"
        stroke="currentColor"
        stroke-width={strokeWidth}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WarningIcon;
